<template>
  <div id="overlay-board">
    <div class="overlay">
      <div class="container">
        <div
          v-show="search_query"
          class="card"
        >
          <div class="card-content">
            <a
              href="#"
              @click.prevent="$emit('handleOnEnter', search_query)"
            >
              <p class="h6 search-query primary">
                <i
                  class="material-icons left"
                  data-icon="search"
                />
                <span class="primary">
                  {{ search_query }}
                </span>
              </p>
            </a>
          </div>
        </div>
        <div
          v-show="!search_query"
        >
          <last-searched
            :locales="locales"
            :marketing_img_src="marketing_img_src"
            :saved_searches="saved_searches"
          />
          <saved-searches
            v-if="saved_searches.length > 0"
            :locales="locales"
            :saved_searches="saved_searches"
            :saved_searchers_url="saved_searches_url"
          />
        </div>
        <suggestions-board
          v-show="search_query"
          :suggestions="suggestions"
          :locale="locale"
          :locales="locales"
          :fetch_url="fetch_url"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OverlayBoard',
  components: {
    LastSearched: () => import('./last_searched.vue'),
    SuggestionsBoard: () => import('./suggestions_board.vue'),
    SavedSearches: () => import('./saved_searches.vue')
  },
  props: {
    search_query: {
      type: String,
      default: ''
    },
    suggestions: {
      type: Object,
      default: () => {}
    },
    fetch_url: {
      type: String,
      default: ''
    },
    locale: {
      type: String,
      default: 'de'
    },
    locales: {
      type: Object,
      default: () => {}
    },
    marketing_img_src: {
      type: String,
      default: ''
    },
    saved_searches: {
      type: Array,
      default: () => []
    },
    saved_searches_url: {
      type: String,
      default: '/saved_searches'
    }
  }
}
</script>